const config =  [
    {
      tittle: "menu.mainPanel",
      navigate: "/",
      icon: "fa-home",
    },
    {

      tittle: "verificationPage.verifications",
      navigate: "/verifications",
      icon: "fa-tasks",
    },
    {

      tittle: "menu.verificationTemplates",
      navigate: "/verificationTemplates",
      icon: "fa-sticky-note",
    },

  ];


export default config;